import { HangingLastMile } from "@/domain/entities/HangingLastMile";
import { ActivitiesDetail, FollowUpDetail, HangingLastMileSummary, HistoryFollowUpLastMile, HistoryFollowUpLastMileEntities } from "@/domain/entities/HangingLastMile";
import { Pagination } from "@/domain/entities/Pagination";
import { AxiosResponse } from "axios";

export class HangingLastMileMapper {

  public convertHangingLastMileSummaryFromApi(res: AxiosResponse<any>): HangingLastMileSummary {
    const {
      data: { data }
    } = res;
    return new HangingLastMileSummary({
      lastSync: data.last_sync,
      activitiesPending: data.activities_pending,
      activitiesDone: data.activities_done,
      totalActivities: data.total_activities,
      courierHangingPending: data.courier_hanging_pending,
      courierHangingDone: data.courier_hanging_done,
      totalCourierHanging: data.total_courier_hanging,
      delHangingPending: data.del_hanging_pending,
      delHangingDone: data.del_hanging_done,
      totalDelHanging: data.total_del_hanging,
      dexHangingPending: data.dex_hanging_pending,
      dexHangingDone: data.dex_hanging_done,
      totalDexHanging: data.total_dex_hanging,
      codrejHangingPending: data.codrej_hanging_pending,
      codrejHangingDone: data.codrej_hanging_done,
      totalCodrejHanging: data.total_codrej_hanging,
    });
  }

  public convertHangingLastMileListFromApi(res: AxiosResponse<any>): HangingLastMile[] {
    const {
      data: { data }
    } = res;
    return data.length ? data.map((item: any) => {
      return new HangingLastMile({
        activityId: item.activity_id,
        activityType: item.activity_type,
        followUpStatus: item.follow_up_status,
        followUpById: item.follow_up_by_id,
        followUpByUsername: item.follow_up_by_username,
        followUpAt: item.follow_up_at,
        followUp: item.follow_up ? {
          courierName: item.follow_up.courier_name,
          courierPhone: item.follow_up.courier_phone
        } : undefined,
        groups: (item.groups || []).map((group: any) => {
          return {
            groupName: group.group_name,
            summary: {
              totalManifest: group.summary.total_manifest,
              totalStt: group.summary.total_stt
            },
            stts: (group.awbs || []).flatMap((awb: any) =>
            (awb.stts || []).map((stt: any) => {
              return {
                no: stt.no,
                noManifest: stt.manifest_no,
                sttNo: stt.stt_no,
                hangingDays: stt.hanging_days,
                existenceStatus: stt.existence_status,
                existenceLocation: stt.existence_location,
                existenceLocationNote: stt.existence_location_note,
                existenceUsername: stt.existence_username,
                existenceFindAt: stt.existence_find_at,
                isAggregator: stt.is_aggregator,
              }
            }))
          }
        })
      })    
    }) : [];
  }

  public convertHistoryFollowUpLastMileFromApi(res: AxiosResponse<any>): HistoryFollowUpLastMileEntities {
    const { data } = res;

    return new HistoryFollowUpLastMileEntities(
      new Pagination(data.meta.page, data.meta.limit, data.meta.total_records),
      (data.data || []).map(
        (item: any) =>
          new HistoryFollowUpLastMile({
            date: item.date,
            activities: (item.activities || []).map(
              (activitie: any) =>
                new ActivitiesDetail({
                  activityId: activitie.activity_id,
                  activityType: activitie.activity_type,
                  statusFollowUp: activitie.status_follow_up,
                  followUp: new FollowUpDetail({
                    courierName: activitie.follow_up?.courier_name || "",
                    courierPhone: activitie.follow_up?.courier_phone || "",
                    username: activitie.follow_up?.username || "",
                    origin3lc: activitie.follow_up?.origin_3lc || "",
                    originName: activitie.follow_up?.origin_name || "",
                  }),
                  username: activitie.username,
                  createdAt: activitie.created_at,
                })
            ),
          })
      )
    );
  }
}

